var App = App || {};

App.ComponentSsYouthsCards = (function ($) {
    'use strict';

    function Init() {
        $(".component-ssYouthsCards").each(function () {
            const widget = $(this);
            CardsFlip(widget);
            Carousel(widget);
        });
    }

    function CardsFlip(widget) {

        const cards = widget.find(".item-ssYouthsCard");
        const buttons = cards.find("button");

        buttons.on("click", function () {
            const card = $(this).parents(".item-ssYouthsCard");
            card.attr("aria-selected", card.attr("aria-selected") == "false");
        })
    }

    function Carousel(widget) {

        const carousel = widget.find(".splide");
        const splide = new Splide(carousel[0], {
            type: "loop",
            perPage: 3,
            gap: "3rem",
            breakpoints: {
                1399: {
                    gap: "1.5rem",
                },
                767: {
                    perPage: 1,
                },
            }
        });

        splide.on('overflow', function (isOverflow) {
            splide.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
            };
        });

        splide.mount({});   
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ComponentSsYouthsCards.Init();
});